import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import Member from './member';

import styles from './team.module.scss';

const Team = ({ title, items }) => (
  <div styleName="container">
    <div className="grid-container">
      <div className="grid-x">
        <div className="cell text-center">
          <h3 styleName="title">{title}</h3>
        </div>
        {items.map(item => (
          <div key={item.image} className="cell small-12 medium-6 large-4">
            <Member {...item} />
          </div>
        ))}
      </div>
    </div>
  </div>
);
Team.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.string,
      social: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.string,
          url: PropTypes.string,
        }),
      ),
    }),
  ),
};
Team.defaultProps = {
  title: '',
  items: [],
};

export const TeamType = PropTypes.shape(Team.propTypes);

export default CSSModules(Team, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/who-we-are/team.jsx